// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT DIRECTLY.

import AlternateHost, { processAlternateHostArray } from "entity/AlternateHost";
import AudioTrack from "entity/AudioTrack";
import CTAItem from "entity/CTAItem";
import CategoryConfig from "entity/CategoryConfig";
import Conversation from "entity/Conversation";
import NavigationItem from "entity/NavigationItem";
import Paging from "./Paging";
import Playlist from "entity/Playlist";
import Social, { processSocial, processSocialArray } from "entity/Social";
import SocialAdmitted, { processSocialAdmitted, processSocialAdmittedArray } from "entity/SocialAdmitted";
import SocialArtifact from "entity/SocialArtifact";
import SocialArtifactSet from "entity/SocialArtifactSet";
import SocialAttendee, { processSocialAttendee, processSocialAttendeeArray } from "entity/SocialAttendee";
import SocialInvite, { processSocialInviteArray } from "entity/SocialInvite";
import SocialMatch, { processSocialMatch } from "entity/SocialMatch";
import SocialRoomSet, { processSocialRoomSet, processSocialRoomSetArray } from "entity/SocialRoomSet";
import SocialSettings from "entity/SocialSettings";
import SocialTemplate, { processSocialTemplateArray } from "entity/SocialTemplate";
import SocialTheme, { processSocialTheme, processSocialThemeArray } from "entity/SocialTheme";
import SocialThemeCategory from "entity/SocialThemeCategory";
import SocialThemeCategoryMap from "entity/SocialThemeCategoryMap";
import StartingPoint from "entity/StartingPoint";

import { QueryParams, RestController, RestRequest } from "./RestController";

export default class SocialController extends RestController {

    addSocialHost(socialId: string, userId: string): Promise<SocialAttendee> {
        let request = new RestRequest("/api/v1/social/" + socialId + "/attendee/host/" + userId + "", "POST", null, undefined);
        return this.request(request, processSocialAttendee) as Promise<SocialAttendee>;
    }

    /*
     Add social theme to social theme category
     */

    apiKeyAddSocialThemeCategoryMapping(socialThemeCategoryId: string, socialThemeId: string): Promise<SocialThemeCategoryMap> {
        let request = new RestRequest("/api/v1/social/api/key/theme/category/mappings", "POST", null, { socialThemeCategoryId: socialThemeCategoryId, socialThemeId: socialThemeId });
        return this.request(request, null) as Promise<SocialThemeCategoryMap>;
    }

    /*
     Create a CTAItem for a social
     */

    apiKeyCreateCTAItem(socialId: string, item: CTAItem): Promise<CTAItem> {
        let request = new RestRequest("/api/v1/social/api/key/" + socialId + "/ctaitem", "POST", item, undefined);
        return this.request(request, null) as Promise<CTAItem>;
    }

    /*
     Create social theme
     */

    apiKeyCreateSocialTheme(theme: SocialTheme, socialThemeCategoryId?: string): Promise<SocialTheme> {
        const queryParams: QueryParams = { };
        if (socialThemeCategoryId !== undefined) {
          queryParams.socialThemeCategoryId = socialThemeCategoryId;
        }
        let request = new RestRequest("/api/v1/social/api/key/theme", "POST", theme, queryParams);
        return this.request(request, processSocialTheme) as Promise<SocialTheme>;
    }

    /*
     Create social theme category
     */

    apiKeyCreateThemeCategory(category: SocialThemeCategory, companyId?: string): Promise<SocialThemeCategory> {
        const queryParams: QueryParams = { };
        if (companyId !== undefined) {
          queryParams.companyId = companyId;
        }
        let request = new RestRequest("/api/v1/social/api/key/theme/category", "POST", category, queryParams);
        return this.request(request, null) as Promise<SocialThemeCategory>;
    }

    /*
     Delete a CTAItem
     */

    apiKeyDeleteCTAItem(CTAItemId: number): Promise<void> {
        let request = new RestRequest("/api/v1/social/api/key/ctaitem/" + CTAItemId + "", "DELETE", null, undefined);
        return this.requestVoid(request);
    }

    /*
     Delete social theme
     */

    apiKeyDeleteSocialTheme(socialThemeId: string): Promise<void> {
        let request = new RestRequest("/api/v1/social/api/key/theme", "DELETE", null, { socialThemeId: socialThemeId });
        return this.requestVoid(request);
    }

    /*
     Delete social theme category
     */

    apiKeyDeleteSocialThemeCategory(socialThemeCategoryId: string): Promise<void> {
        let request = new RestRequest("/api/v1/social/api/key/theme/category", "DELETE", null, { socialThemeCategoryId: socialThemeCategoryId });
        return this.requestVoid(request);
    }

    /*
     Get CTAItems for a social
     */

    apiKeyGetCTAItems(socialId: string, page?: Paging): Promise<CTAItem[]> {
        let request = new RestRequest("/api/v1/social/api/key/" + socialId + "/ctaitem", "GET", null, undefined);
        if (page) request.addPaging("", page);

        return this.request(request, null) as Promise<CTAItem[]>;
    }

    /*
     Get social theme categories for a company
     */

    apiKeyGetSocialThemeCategories(companyId?: string, page?: Paging): Promise<SocialThemeCategory[]> {
        const queryParams: QueryParams = { };
        if (companyId !== undefined) {
          queryParams.companyId = companyId;
        }
        let request = new RestRequest("/api/v1/social/api/key/theme/category/company", "GET", null, queryParams);
        if (page) request.addPaging("", page);

        return this.request(request, null) as Promise<SocialThemeCategory[]>;
    }

    /*
     Get social theme category
     */

    apiKeyGetSocialThemeCategory(socialThemeCategoryId: string): Promise<SocialThemeCategory> {
        let request = new RestRequest("/api/v1/social/api/key/theme/category", "GET", null, { socialThemeCategoryId: socialThemeCategoryId });
        return this.request(request, null) as Promise<SocialThemeCategory>;
    }

    /*
     Get social theme category
     */

    apiKeyGetSocialThemeCategoryMappings(socialThemeCategoryId: string, page?: Paging): Promise<SocialThemeCategoryMap[]> {
        let request = new RestRequest("/api/v1/social/api/key/theme/category/mappings", "GET", null, { socialThemeCategoryId: socialThemeCategoryId });
        if (page) request.addPaging("", page);

        return this.request(request, null) as Promise<SocialThemeCategoryMap[]>;
    }

    /*
     Remove social theme from social theme category
     */

    apiKeyRemoveSocialThemeCategoryMapping(socialThemeCategoryId: string, socialThemeId: string): Promise<void> {
        let request = new RestRequest("/api/v1/social/api/key/theme/category/mappings", "DELETE", null, { socialThemeCategoryId: socialThemeCategoryId, socialThemeId: socialThemeId });
        return this.requestVoid(request);
    }

    /*
     Update a CTAItem
     */

    apiKeyUpdateCTAItem(item: CTAItem): Promise<CTAItem> {
        let request = new RestRequest("/api/v1/social/api/key/ctaitem", "PATCH", item, undefined);
        return this.request(request, null) as Promise<CTAItem>;
    }

    /*
     Update social theme
     */

    apiKeyUpdateSocialTheme(theme: SocialTheme): Promise<SocialTheme> {
        let request = new RestRequest("/api/v1/social/api/key/theme", "PATCH", theme, undefined);
        return this.request(request, processSocialTheme) as Promise<SocialTheme>;
    }

    /*
     Update social theme from social theme category
     */

    apiKeyUpdateSocialThemeCategoryMapping(socialThemeCategoryId: string, socialThemeId: string, displayOrder: number): Promise<SocialThemeCategoryMap> {
        let request = new RestRequest("/api/v1/social/api/key/theme/category/mappings/update", "POST", null, { socialThemeCategoryId: socialThemeCategoryId, socialThemeId: socialThemeId, displayOrder: displayOrder });
        return this.request(request, null) as Promise<SocialThemeCategoryMap>;
    }

    /*
     Check if user can join this social.
     */

    canJoinSocial(socialId: string): Promise<boolean> {
        let request = new RestRequest("/api/v1/social/join/" + socialId + "", "GET", null, undefined);
        return this.request(request, null) as Promise<boolean>;
    }

    /*
     Cancel social by seting isValid to false and prevent people from attending.
     */

    cancelSocial(socialId: string): Promise<Social> {
        let request = new RestRequest("/api/v1/social/cancel/" + socialId + "", "POST", null, undefined);
        return this.request(request, processSocial) as Promise<Social>;
    }

    /*
     Check if user has been admitted, if not notify hosts about users trying to join.
     */

    checkAdmittedStatus(socialId: string, notifyHosts?: boolean): Promise<SocialAdmitted> {
        const queryParams: QueryParams = { };
        if (notifyHosts !== undefined) {
          queryParams.notifyHosts = notifyHosts;
        }
        let request = new RestRequest("/api/v1/social/admitted/" + socialId + "", "GET", null, queryParams);
        return this.request(request, processSocialAdmitted) as Promise<SocialAdmitted>;
    }

    closeSocialRoomSet(roomSetId: string): Promise<void> {
        let request = new RestRequest("/api/v1/social/room/set/" + roomSetId + "/close", "POST", null, undefined);
        return this.requestVoid(request);
    }

    /*
     Copy a CTAItem
     */

    copyCTAItem(CTAItemId: number, name: string): Promise<CTAItem> {
        let request = new RestRequest("/api/v1/social/ctaitem/copy", "POST", null, { CTAItemId: CTAItemId, name: name });
        return this.request(request, null) as Promise<CTAItem>;
    }

    /*
     Copy social.
     */

    copySocial(socialId: string, socialName: string): Promise<Social> {
        let request = new RestRequest("/api/v1/social/copy", "POST", null, { socialId: socialId, socialName: socialName });
        return this.request(request, processSocial) as Promise<Social>;
    }

    /*
     Copy social room set.
     */

    copySocialRoomSet(socialRoomSetId: string, roomSetName: string): Promise<SocialRoomSet> {
        let request = new RestRequest("/api/v1/social/room/set/copy", "POST", null, { socialRoomSetId: socialRoomSetId, roomSetName: roomSetName });
        return this.request(request, processSocialRoomSet) as Promise<SocialRoomSet>;
    }

    /*
     Create a CTAItem for a social
     */

    createCTAItem(socialId: string, item: CTAItem): Promise<CTAItem> {
        let request = new RestRequest("/api/v1/social/" + socialId + "/ctaitem", "POST", item, undefined);
        return this.request(request, null) as Promise<CTAItem>;
    }

    /*
     Create empty social room set.
     */

    createEmptySocialRoomSet(socialRoomSet: SocialRoomSet): Promise<SocialRoomSet> {
        let request = new RestRequest("/api/v1/social/room/set/create/empty", "POST", socialRoomSet, undefined);
        return this.request(request, processSocialRoomSet) as Promise<SocialRoomSet>;
    }

    /*
     Generates an URI for social. New room set is created if room set id is omitted otherwise it is added to existing one.
     */

    createSocial(social: Social, socialRoomSetId?: string): Promise<Social> {
        const queryParams: QueryParams = { };
        if (socialRoomSetId !== undefined) {
          queryParams.socialRoomSetId = socialRoomSetId;
        }
        let request = new RestRequest("/api/v1/social/create", "POST", social, queryParams);
        return this.request(request, processSocial) as Promise<Social>;
    }

    /*
     Create social invites by takin each and send out email or notifications to each user with the URI for the social.
     */

    createSocialInvites(socialId: string, socialInvites: SocialInvite[]): Promise<SocialInvite[]> {
        let request = new RestRequest("/api/v1/social/invite/" + socialId + "", "POST", socialInvites, undefined);
        return this.request(request, processSocialInviteArray) as Promise<SocialInvite[]>;
    }

    /*
     Delete a CTAItem
     */

    deleteCTAItem(CTAItemId: number): Promise<void> {
        let request = new RestRequest("/api/v1/social/ctaitem/" + CTAItemId + "", "DELETE", null, undefined);
        return this.requestVoid(request);
    }

    /*
     Delete social room set.
     */

    deleteSocialRoomSet(socialRoomSetId: string): Promise<void> {
        let request = new RestRequest("/api/v1/social/room/set", "DELETE", null, { socialRoomSetId: socialRoomSetId });
        return this.requestVoid(request);
    }

    endAllSocials(): Promise<void> {
        let request = new RestRequest("/api/v1/social/end/all", "POST", null, undefined);
        return this.requestVoid(request);
    }

    /*
     Ends social. Needs to be executed by the user who created social or SocialAttendee who isHost == true. Upon ending social we may need to call OpenTok API to invalidate the session. leaveOpenUntilDateTime optional parameter can be provided to leave session open until a specific time and then have it shutdown at that time
     */

    endSocial(socialId: string, leaveOpenUntil?: Date): Promise<Social> {
        const queryParams: QueryParams = { };
        if (leaveOpenUntil !== undefined) {
          queryParams.leaveOpenUntil = leaveOpenUntil;
        }
        let request = new RestRequest("/api/v1/social/end/" + socialId + "", "POST", null, queryParams);
        return this.request(request, processSocial) as Promise<Social>;
    }

    /*
     Get playlists
     */

    getAllPlaylists(page?: Paging): Promise<Playlist[]> {
        let request = new RestRequest("/api/v1/social/playlist/all", "GET", null, undefined);
        if (page) request.addPaging("", page);

        return this.request(request, null) as Promise<Playlist[]>;
    }

    /*
     Get socials that user is allowed to enter.
     */

    getAllowedSocials(page?: Paging): Promise<Social[]> {
        let request = new RestRequest("/api/v1/social/allowed", "GET", null, undefined);
        if (page) request.addPaging("", page);

        return this.request(request, processSocialArray) as Promise<Social[]>;
    }

    /*
     Get alternate host candidates
     */

    getAlternateHostCandidates(socialId: string, text?: string, page?: Paging): Promise<AlternateHost[]> {
        const queryParams: QueryParams = { };
        if (text !== undefined) {
          queryParams.text = text;
        }
        let request = new RestRequest("/api/v1/social/alternate/host/" + socialId + "", "GET", null, queryParams);
        if (page) request.addPaging("", page);

        return this.request(request, processAlternateHostArray) as Promise<AlternateHost[]>;
    }

    /*
     Get alternate host candidates for a Scootaverse
     */

    getAlternateRoomSetHostCandidates(socialRoomSetId: string, text?: string, page?: Paging): Promise<AlternateHost[]> {
        const queryParams: QueryParams = { };
        if (text !== undefined) {
          queryParams.text = text;
        }
        let request = new RestRequest("/api/v1/social/alternate/host/room/set/" + socialRoomSetId + "", "GET", null, queryParams);
        if (page) request.addPaging("", page);

        return this.request(request, processAlternateHostArray) as Promise<AlternateHost[]>;
    }

    /*
     Get artifacts sets
     */

    getArtifactSets(page?: Paging): Promise<SocialArtifactSet[]> {
        let request = new RestRequest("/api/v1/social/artifact/set", "GET", null, undefined);
        if (page) request.addPaging("", page);

        return this.request(request, null) as Promise<SocialArtifactSet[]>;
    }

    /*
     Get artifacts for a set
     */

    getArtifacts(artifactSetId: string): Promise<SocialArtifact[]> {
        let request = new RestRequest("/api/v1/social/artifact/set/" + artifactSetId + "/artifact", "GET", null, undefined);
        return this.request(request, null) as Promise<SocialArtifact[]>;
    }

    /*
     Get audio tracks for a playlist
     */

    getAudioTracks(playlistId: string, page?: Paging): Promise<AudioTrack[]> {
        let request = new RestRequest("/api/v1/social/playlist/" + playlistId + "/track", "GET", null, undefined);
        if (page) request.addPaging("", page);

        return this.request(request, null) as Promise<AudioTrack[]>;
    }

    /*
     Get CTAItems for a social
     */

    getCTAItems(socialId: string, page?: Paging): Promise<CTAItem[]> {
        let request = new RestRequest("/api/v1/social/" + socialId + "/ctaitem", "GET", null, undefined);
        if (page) request.addPaging("", page);

        return this.request(request, null) as Promise<CTAItem[]>;
    }

    /*
     Get conversation categories
     */

    getCategories(page?: Paging): Promise<CategoryConfig[]> {
        let request = new RestRequest("/api/v1/social/convo/category", "GET", null, undefined);
        if (page) request.addPaging("", page);

        return this.request(request, null) as Promise<CategoryConfig[]>;
    }

    /*
     Get a conversation
     */

    getConversation(conversationId: number): Promise<Conversation> {
        let request = new RestRequest("/api/v1/social/conversation/" + conversationId + "", "GET", null, undefined);
        return this.request(request, null) as Promise<Conversation>;
    }

    /*
     Get conversations for a category
     */

    getConversations(categoryId: number, page?: Paging): Promise<Conversation[]> {
        let request = new RestRequest("/api/v1/social/conversation/category/" + categoryId + "", "GET", null, undefined);
        if (page) request.addPaging("", page);

        return this.request(request, null) as Promise<Conversation[]>;
    }

    /*
     Return frame rate for video feeds.
     */

    getFrameRate(): Promise<number> {
        let request = new RestRequest("/api/v1/social/frame/rate", "GET", null, undefined);
        return this.request(request, null) as Promise<number>;
    }

    /*
     Return how many socials user can save. 0 is unlimited.
     */

    getMaxSavedCount(): Promise<number> {
        let request = new RestRequest("/api/v1/social/max/saved/count", "GET", null, undefined);
        return this.request(request, null) as Promise<number>;
    }

    /*
     Get my social room sets.
     */

    getMySocialRoomSets(page?: Paging): Promise<SocialRoomSet[]> {
        let request = new RestRequest("/api/v1/social/room/set/mine", "GET", null, undefined);
        if (page) request.addPaging("", page);

        return this.request(request, processSocialRoomSetArray) as Promise<SocialRoomSet[]>;
    }

    /*
     Get socials that user has saved or are currently open.
     */

    getMySocials(includeOpen?: boolean, page?: Paging): Promise<Social[]> {
        const queryParams: QueryParams = { };
        if (includeOpen !== undefined) {
          queryParams.includeOpen = includeOpen;
        }
        let request = new RestRequest("/api/v1/social/saved", "GET", null, queryParams);
        if (page) request.addPaging("", page);

        return this.request(request, processSocialArray) as Promise<Social[]>;
    }

    /*
     Get navigation items
     */

    getNavigationItems(navigationItemSetId: string): Promise<NavigationItem[]> {
        let request = new RestRequest("/api/v1/social/navigation/item/set/" + navigationItemSetId + "/item", "GET", null, undefined);
        return this.request(request, null) as Promise<NavigationItem[]>;
    }

    /*
     Get a playlist by id
     */

    getPlaylist(playlistId: string): Promise<Playlist> {
        let request = new RestRequest("/api/v1/social/playlist/" + playlistId + "", "GET", null, undefined);
        return this.request(request, null) as Promise<Playlist>;
    }

    /*
     Get playlists
     */

    getPlaylists(page?: Paging): Promise<Playlist[]> {
        let request = new RestRequest("/api/v1/social/playlist", "GET", null, undefined);
        if (page) request.addPaging("", page);

        return this.request(request, null) as Promise<Playlist[]>;
    }

    /*
     Get a social.
     */

    getSocial(socialId: string, allocateServer?: boolean, region?: string, getBadgeData?: boolean): Promise<Social> {
        const queryParams: QueryParams = { };
        if (allocateServer !== undefined) {
          queryParams.allocateServer = allocateServer;
        }
        if (region !== undefined) {
          queryParams.region = region;
        }
        if (getBadgeData !== undefined) {
          queryParams.getBadgeData = getBadgeData;
        }
        let request = new RestRequest("/api/v1/social/" + socialId + "", "GET", null, queryParams);
        return this.request(request, processSocial) as Promise<Social>;
    }

    /*
     Get artifacts for a social
     */

    getSocialArtifacts(socialId: string): Promise<SocialArtifact[]> {
        let request = new RestRequest("/api/v1/social/" + socialId + "/artifact", "GET", null, undefined);
        return this.request(request, null) as Promise<SocialArtifact[]>;
    }

    /*
     Get social attendee
     */

    getSocialAttendee(socialAttendeeId: string): Promise<SocialAttendee> {
        let request = new RestRequest("/api/v1/social/attendee/" + socialAttendeeId + "", "GET", null, undefined);
        return this.request(request, processSocialAttendee) as Promise<SocialAttendee>;
    }

    /*
     Get social attendee by stream connection id
     */

    getSocialAttendeeByConnectionId(streamConnectionid: string): Promise<SocialAttendee> {
        let request = new RestRequest("/api/v1/social/attendee/by/connection/id/" + streamConnectionid + "", "GET", null, undefined);
        return this.request(request, processSocialAttendee) as Promise<SocialAttendee>;
    }

    /*
     Get social attendees. isPresent optional parameter can be provided to limit results to those in current attendance - otherwise return all if not provided
     */

    getSocialAttendees(socialId: string, isPresent?: boolean, page?: Paging): Promise<SocialAttendee[]> {
        const queryParams: QueryParams = { };
        if (isPresent !== undefined) {
          queryParams.isPresent = isPresent;
        }
        let request = new RestRequest("/api/v1/social/" + socialId + "/attendees", "GET", null, queryParams);
        if (page) request.addPaging("", page);

        return this.request(request, processSocialAttendeeArray) as Promise<SocialAttendee[]>;
    }

    /*
     Get social invites
     */

    getSocialInvites(socialId: string, page?: Paging): Promise<SocialInvite[]> {
        let request = new RestRequest("/api/v1/social/" + socialId + "/invites", "GET", null, undefined);
        if (page) request.addPaging("", page);

        return this.request(request, processSocialInviteArray) as Promise<SocialInvite[]>;
    }

    /*
     Get social room set.
     */

    getSocialRoomSet(roomSetIdentifier: string): Promise<SocialRoomSet> {
        let request = new RestRequest("/api/v1/social/room/set/" + roomSetIdentifier + "", "GET", null, undefined);
        return this.request(request, processSocialRoomSet) as Promise<SocialRoomSet>;
    }

    /*
     Get settings for a Scootaverse
     */

    getSocialRoomSetSettings(socialRoomSetId: string): Promise<SocialSettings> {
        let request = new RestRequest("/api/v1/social/room/set/settings/" + socialRoomSetId + "", "GET", null, undefined);
        return this.request(request, null) as Promise<SocialSettings>;
    }

    /*
     Get settings for a social
     */

    getSocialSettings(socialId: string): Promise<SocialSettings> {
        let request = new RestRequest("/api/v1/social/settings/" + socialId + "", "GET", null, undefined);
        return this.request(request, null) as Promise<SocialSettings>;
    }

    /*
     Get social themes
     */

    getSocialThemes(page?: Paging): Promise<SocialTheme[]> {
        let request = new RestRequest("/api/v1/social/theme", "GET", null, undefined);
        if (page) request.addPaging("", page);

        return this.request(request, processSocialThemeArray) as Promise<SocialTheme[]>;
    }

    /*
     Get starting point for a room set
     */

    getStartingPoint(socialRoomSetId: string): Promise<StartingPoint> {
        let request = new RestRequest("/api/v1/social/starting/point", "GET", null, { socialRoomSetId: socialRoomSetId });
        return this.request(request, null) as Promise<StartingPoint>;
    }

    /*
     Get social templates
     */

    getTemplates(page?: Paging): Promise<SocialTemplate[]> {
        let request = new RestRequest("/api/v1/social/template", "GET", null, undefined);
        if (page) request.addPaging("", page);

        return this.request(request, processSocialTemplateArray) as Promise<SocialTemplate[]>;
    }

    /*
     Get social theme category
     */

    getThemeCategories(page?: Paging): Promise<SocialThemeCategory[]> {
        let request = new RestRequest("/api/v1/social/theme/category", "GET", null, undefined);
        if (page) request.addPaging("", page);

        return this.request(request, null) as Promise<SocialThemeCategory[]>;
    }

    /*
     Get social themes for a category
     */

    getThemesForCategory(socialThemeCategoryId: string, page?: Paging): Promise<SocialTheme[]> {
        let request = new RestRequest("/api/v1/social/theme/category/" + socialThemeCategoryId + "", "GET", null, undefined);
        if (page) request.addPaging("", page);

        return this.request(request, processSocialThemeArray) as Promise<SocialTheme[]>;
    }

    /*
     Check if user has completed social demo
     */

    hasCompletedDemo(): Promise<boolean> {
        let request = new RestRequest("/api/v1/social/demo/completed", "GET", null, undefined);
        return this.request(request, null) as Promise<boolean>;
    }

    /*
     Check if user has access to host socials.
     */

    isSocialAvailable(): Promise<boolean> {
        let request = new RestRequest("/api/v1/social/available", "GET", null, undefined);
        return this.request(request, null) as Promise<boolean>;
    }

    /*
     Check if request access is visible to the user.
     */

    isSocialVisible(): Promise<boolean> {
        let request = new RestRequest("/api/v1/social/visible", "GET", null, undefined);
        return this.request(request, null) as Promise<boolean>;
    }

    /*
     Join social. Attempts to use current user logged in to join social by checking against invited list and isOpen and isValid flags of Social. Also should check for existing SocialAttendee for current User already created in event they left and are returning. Should return SocialAttendee object. Should also set flags on SocialInvite as didAttend=true and isPresent in SocialAttendee object to true in addition to relevant datetime stamps
     */

    joinSocial(socialId: string): Promise<SocialAttendee> {
        let request = new RestRequest("/api/v1/social/join/" + socialId + "", "POST", null, undefined);
        return this.request(request, processSocialAttendee) as Promise<SocialAttendee>;
    }

    /*
     Launch audio player
     */

    launchAudioPlayer(server: string, region: string): Promise<void> {
        let request = new RestRequest("/api/v1/social/launch/player", "POST", server, { region: region });
        return this.requestVoid(request);
    }

    /*
     Leave social
     */

    leaveSocial(socialId: string): Promise<SocialAttendee> {
        let request = new RestRequest("/api/v1/social/" + socialId + "/attendee/leave", "POST", null, undefined);
        return this.request(request, processSocialAttendee) as Promise<SocialAttendee>;
    }

    /*
     Try to match id to a social.
     */

    matchSocial(matchedId: string): Promise<SocialMatch> {
        let request = new RestRequest("/api/v1/social/match", "GET", null, { matchedId: matchedId });
        return this.request(request, processSocialMatch) as Promise<SocialMatch>;
    }

    /*
     Next audio track
     */

    nextAudioTrack(socialId: string): Promise<AudioTrack> {
        let request = new RestRequest("/api/v1/social/" + socialId + "/audio/next", "POST", null, undefined);
        return this.request(request, null) as Promise<AudioTrack>;
    }

    /*
     Play audio track
     */

    playAudioTrack(socialId: string, playlistId: string, audioTrackId?: string): Promise<AudioTrack> {
        const queryParams: QueryParams = { };
        if (audioTrackId !== undefined) {
          queryParams.audioTrackId = audioTrackId;
        }
        let request = new RestRequest("/api/v1/social/" + socialId + "/audio/" + playlistId + "", "POST", null, queryParams);
        return this.request(request, null) as Promise<AudioTrack>;
    }

    /*
     Resume playing
     */

    resumePlaying(socialId: string): Promise<void> {
        let request = new RestRequest("/api/v1/social/" + socialId + "/audio/resume", "POST", null, undefined);
        return this.requestVoid(request);
    }

    /*
     Save video quality to use when user is presenting.
     */

    savePresenterVideoQuality(quality: string): Promise<void> {
        let request = new RestRequest("/api/v1/social/presenter/video/quality", "POST", null, { quality: quality });
        return this.requestVoid(request);
    }

    /*
     Save settings for a Scootaverse
     */

    saveSocialRoomSetSettings(socialRoomSetId: string, settings: SocialSettings): Promise<void> {
        let request = new RestRequest("/api/v1/social/room/set/settings/" + socialRoomSetId + "", "POST", settings, undefined);
        return this.requestVoid(request);
    }

    /*
     Save settings for a social
     */

    saveSocialSettings(socialId: string, settings: SocialSettings): Promise<void> {
        let request = new RestRequest("/api/v1/social/settings/" + socialId + "", "POST", settings, undefined);
        return this.requestVoid(request);
    }

    /*
     Allow user to join social or ban them from social
     */

    setAdmittedStatus(socialId: string, userId: string, admit: boolean, ban: boolean, allRooms?: boolean): Promise<SocialAdmitted> {
        const queryParams: QueryParams = { admit: admit, ban: ban };
        if (allRooms !== undefined) {
          queryParams.allRooms = allRooms;
        }
        let request = new RestRequest("/api/v1/social/admitted/" + socialId + "/" + userId + "", "POST", null, queryParams);
        return this.request(request, processSocialAdmitted) as Promise<SocialAdmitted>;
    }

    /*
     Allow users to join social or ban them from social
     */

    setAdmittedStatuses(socialId: string, userIds: unknown, admit: boolean, ban: boolean, allRooms?: boolean): Promise<SocialAdmitted[]> {
        const queryParams: QueryParams = { admit: admit, ban: ban };
        if (allRooms !== undefined) {
          queryParams.allRooms = allRooms;
        }
        let request = new RestRequest("/api/v1/social/admitted/" + socialId + "", "POST", userIds, queryParams);
        return this.request(request, processSocialAdmittedArray) as Promise<SocialAdmitted[]>;
    }

    /*
     Set that user has completed social demo
     */

    setDemoCompleted(): Promise<void> {
        let request = new RestRequest("/api/v1/social/demo/completed", "POST", null, undefined);
        return this.requestVoid(request);
    }

    /*
     Set frame rate for a social
     */

    setFrameRate(socialId: string, frameRate?: number): Promise<string> {
        const queryParams: QueryParams = { };
        if (frameRate !== undefined) {
          queryParams.frameRate = frameRate;
        }
        let request = new RestRequest("/api/v1/social/" + socialId + "/frame/rate", "POST", null, queryParams);
        return this.request(request, null) as Promise<string>;
    }

    /*
     Check if banner should be visible.
     */

    showBanner(socialId: string): Promise<boolean> {
        let request = new RestRequest("/api/v1/social/" + socialId + "/show/banner", "GET", null, undefined);
        return this.request(request, null) as Promise<boolean>;
    }

    /*
     Starts social by setting isOpen to true.
     */

    startSocial(socialId: string, region?: string): Promise<Social> {
        const queryParams: QueryParams = { };
        if (region !== undefined) {
          queryParams.region = region;
        }
        let request = new RestRequest("/api/v1/social/start/" + socialId + "", "POST", null, queryParams);
        return this.request(request, processSocial) as Promise<Social>;
    }

    /*
     Stop playing
     */

    stopPlaying(socialId: string): Promise<void> {
        let request = new RestRequest("/api/v1/social/" + socialId + "/audio/stop", "POST", null, undefined);
        return this.requestVoid(request);
    }

    /*
     Update alternate hosts by removing or adding
     */

    updateAlternateHosts(socialId: string, updates: AlternateHost[]): Promise<void> {
        let request = new RestRequest("/api/v1/social/alternate/host/" + socialId + "", "POST", updates, undefined);
        return this.requestVoid(request);
    }

    /*
     Update alternate hosts by removing or adding for a Scootaverse
     */

    updateAlternateRoomSetHosts(socialRoomSetId: string, updates: AlternateHost[]): Promise<void> {
        let request = new RestRequest("/api/v1/social/alternate/host/room/set/" + socialRoomSetId + "", "POST", updates, undefined);
        return this.requestVoid(request);
    }

    /*
     Update a CTAItem
     */

    updateCTAItem(item: CTAItem): Promise<CTAItem> {
        let request = new RestRequest("/api/v1/social/ctaitem", "PATCH", item, undefined);
        return this.request(request, null) as Promise<CTAItem>;
    }

    /*
     Update social name, description, theme, startdatetime, enddatetime, isOpen and isValid properties only
     */

    updateSocial(social: Social): Promise<Social> {
        let request = new RestRequest("/api/v1/social/update", "POST", social, undefined);
        return this.request(request, processSocial) as Promise<Social>;
    }

    /*
     Update social attendee
     */

    updateSocialAttendee(socialAttendee: SocialAttendee): Promise<SocialAttendee> {
        let request = new RestRequest("/api/v1/social/attendee", "POST", socialAttendee, undefined);
        return this.request(request, processSocialAttendee) as Promise<SocialAttendee>;
    }

    /*
     Update social room set.
     */

    updateSocialRoomSet(socialRoomSet: SocialRoomSet): Promise<void> {
        let request = new RestRequest("/api/v1/social/room/set", "PATCH", socialRoomSet, undefined);
        return this.requestVoid(request);
    }

    /*
     Update starting point
     */

    updateStartingPoint(socialRoomSetId: string, startingPoint: StartingPoint): Promise<void> {
        let request = new RestRequest("/api/v1/social/starting/point", "POST", startingPoint, { socialRoomSetId: socialRoomSetId });
        return this.requestVoid(request);
    }

}
